/** Canonical filter key for fall-related critical events in the UI. */
export const FALL_EVENT_TYPE = 'fall';

export function isFallEvent(eventType: string): boolean {
  const t = (eventType || '').toLowerCase().trim();
  if (t === FALL_EVENT_TYPE || t === 'fall_detected') return true;
  return t.startsWith('fall_');
}

export function normalizeFallEventTypeForUi(_eventType: string): string {
  return FALL_EVENT_TYPE;
}

export function getFallDisplayLabel(_eventType?: string): string {
  return 'Fall Detected';
}
